document.addEventListener('DOMContentLoaded', function () {

  function updateActivePrice() {
    document.querySelectorAll('.vintalia-price-options').forEach(function(wrapper) {
      const url = new URL(window.location.href);

      const minParam = wrapper.dataset.priceMinParam;
      const maxParam = wrapper.dataset.priceMaxParam;

      const currentMin = url.searchParams.get(minParam) || '';
      const currentMax = url.searchParams.get(maxParam) || '';

      wrapper.querySelectorAll('.vintalia-price-option').forEach(function(button) {
        const isActive =
          button.dataset.min === currentMin &&
          button.dataset.max === currentMax;

        button.classList.toggle('is-active', isActive);
      });
    });
  }

  document.addEventListener('click', function(event) {
    const button = event.target.closest('.vintalia-price-option');
    if (!button) return;

    const wrapper = button.closest('.vintalia-price-options');
    if (!wrapper) return;

    const url = new URL(window.location.href);

    const minParam = wrapper.dataset.priceMinParam;
    const maxParam = wrapper.dataset.priceMaxParam;

    url.searchParams.delete(minParam);
    url.searchParams.delete(maxParam);
    url.searchParams.delete('page');

    if (button.dataset.min) {
      url.searchParams.set(minParam, button.dataset.min);
    }

    if (button.dataset.max) {
      url.searchParams.set(maxParam, button.dataset.max);
    }

    window.location.href = url.toString();
  });

  updateActivePrice();
});